import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import UnifiedComputeResource from "../UnifiedCompute.resource.js";
const defaultReducerState = {
  res: getDefaultAsyncWrapperObj()
};
const prefix = "getCompute";
const CLEAR_GET_COMPUTE_STATE = `${prefix}/CLEAR_STATE`;
const clearGetComputeState = () => {
  return {
    type: CLEAR_GET_COMPUTE_STATE,
    payload: {}
  };
};
const getComputeArgs = {
  actionPrefix: `${prefix}/LOAD`,
  reduxKeyNested: () => ["res"],
  loadResource: (inputPayload) => {
    return UnifiedComputeResource.getCompute(inputPayload.workspaceId, inputPayload.id);
  },
  onCompleteSuccess: (resourceResult) => resourceResult
};
const getComputeEpicReducer = loadResourcesUtils(getComputeArgs);
const getComputeReducer = (state = defaultReducerState, action) => {
  switch (action.type) {
    case CLEAR_GET_COMPUTE_STATE:
      return defaultReducerState;
    default:
      return getComputeEpicReducer.reduxChange(state, action);
  }
};
export {
  clearGetComputeState,
  getComputeReducer as default,
  defaultReducerState,
  getComputeEpicReducer,
  getComputeReducer
};
//# sourceMappingURL=GetCompute.ducks.js.map
